var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"persistent":"","fullscreen":"","retain-focus":false,"transition":"dialog-bottom-transition-10"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('viewProfileDialog',{attrs:{"profile":_vm.profile},on:{"hide":_vm.handleDialogHide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }